import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ShimmerInput = ({ className, style }) => {
  return (
    <>
      <div
        style={style}
        className={classNames({
          grid: true,
          'shimmer-title w-50': true,
          [`grid-gap-10`]: 10,
          [className]: className,
        })}>
        <div className="shimmer shimmer-title-line w-25" />
      </div>
      <div
        style={style}
        className={classNames({
          grid: true,
          'shimmer-title w-100': true,
          [`grid-gap-10`]: 10,
          [className]: className,
        })}>
        <div className="shimmer shimmer-title-line " style={{ height: '45px' }} />
      </div>
    </>
  );
};
ShimmerInput.propTypes = {
  style: PropTypes.any,
  className: PropTypes.any,
};

export default ShimmerInput;
